/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * This directive displays auto-save status events <b>$emit</b>ed by bulb-auto-save directives in contained scopes.
 */

angular.module('bulbApp.autoSaveModule')
  .directive('bulbAutoSaveStatus', [
    '$log',
    '$rootScope',
    '$timeout',
    '$window',
    'BulbModalService',
    'ErrorService',
    'SaveStateStore',
    'AUTO_SAVE',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    bulbAutoSaveStatus,
  ]);

function bulbAutoSaveStatus(
  $log,
  $rootScope,
  $timeout,
  $window,
  BulbModalService,
  ErrorService,
  SaveStateStore,
  AUTO_SAVE,
) {
  return {
    restrict: 'E',
    scope: {},
    template: '{{autoSaveStatus | translate}}',
    link: function link(scope, element) {
      // Configure the auto-save to never overlap with the footer upon loading. We can use the values here
      // because the auto-save is not shown at all on small devices.
      $timeout(() => {
        const pageFooterHeight = $('.bulb-page-post-footer').outerHeight();
        $(element).parent().css('bottom', `${pageFooterHeight + 28}px`);
      });

      // eslint-disable-next-line no-param-reassign
      scope.autoSaveStatus = AUTO_SAVE.STATUS.PRISTINE;
      let savingReferenceCount = 0;
      let errorEncountered = false;
      let bodyMessage;

      const statusEnum = SaveStateStore.getStatusEnum();
      const saveStatusSub = SaveStateStore.status$.subscribe((status) => {
        switch (status) {

          case statusEnum.SAVED:
            // leave as pristine until a save comes in
            if (scope.autoSaveStatus !== AUTO_SAVE.STATUS.PRISTINE) {
              // eslint-disable-next-line no-param-reassign
              scope.autoSaveStatus = AUTO_SAVE.STATUS.SAVED;
              element.removeClass('bulb-auto-save-error');
            }
            break;

          case statusEnum.SAVING:
            // eslint-disable-next-line no-param-reassign
            scope.autoSaveStatus = AUTO_SAVE.STATUS.SAVING;
            element.removeClass('bulb-auto-save-error');
            break;

          case statusEnum.RETRYING_SAVE:
            // eslint-disable-next-line no-param-reassign
            scope.autoSaveStatus = AUTO_SAVE.STATUS.RETRYING;
            element.addClass('bulb-auto-save-error');
            break;

          case statusEnum.ERROR:
          case statusEnum.REVISION_MISMATCH:
            // eslint-disable-next-line no-param-reassign
            scope.autoSaveStatus = AUTO_SAVE.STATUS.ERROR;
            element.addClass('bulb-auto-save-error');
            bodyMessage = status === statusEnum.REVISION_MISMATCH
              ? 'AUTO_SAVE_REVISION_MISMATCH' : 'AUTO_SAVE_ERROR_BODY';

            BulbModalService.show({
              titleCode: 'AUTO_SAVE_ERROR',
              bodyCode: bodyMessage,
              okButtonCode: 'button_refresh',
              fontAwesomeCode: 'fa fa-exclamation-triangle',
              windowClass: 'bulb-aero-modal-body bulb-aero-modal-buttons bulb-aero-modal-buttons-single-btn',
              showCancelButton: false,
            }).then(() => {
              $window.location.reload();
            });
            break;

          default:
            ErrorService.captureErrorMessage(`Unrecognized SerialSaveService.Status: ${status}`);
            break;
        }
      });

      scope.$on('$destroy', () => {
        saveStatusSub.unsubscribe();
      });
    },
  };
}
